<mat-form-field style="width: 100%">
    <mat-label>Passwort</mat-label>
    <input [type]="showPassword ? 'text' : 'password'" placeholder="Passwort" matInput [formControl]="passwordCtrl" />
    <button mat-icon-button matSuffix (click)="showPassword = !showPassword" type="button">
        <mat-icon>{{ showPassword ? "visibility_off" : "visibility" }}</mat-icon>
    </button>
    <mat-error *ngIf="passwordCtrl.invalid">Bitte Passwort eintragen!</mat-error>
</mat-form-field>
<mat-form-field style="width: 100%; margin-top: 24px">
    <mat-label>Passwort wiederholen</mat-label>
    <input
        [type]="showPasswordRepeat ? 'text' : 'password'"
        placeholder="Passwort wiederholen"
        matInput
        [formControl]="passwordConfirmCtrl"
    />
    <button mat-icon-button matSuffix (click)="showPasswordRepeat = !showPasswordRepeat" type="button">
        <mat-icon>{{ showPasswordRepeat ? "visibility_off" : "visibility" }}</mat-icon>
    </button>
    <mat-error *ngIf="passwordConfirmCtrl.invalid">Passwort stimmt nicht überein! </mat-error>
</mat-form-field>

<div class="password-requirements" *ngIf="passwordCtrl.value?.length > 0 || passwordConfirmCtrl.value?.length > 0">
    <h4>Passwort-Anforderungen:</h4>
    <ul>
        <li [class.valid]="passwordValidation.minLength" [class.invalid]="!passwordValidation.minLength">
            <mat-icon>{{ passwordValidation.minLength ? 'check_circle' : 'cancel' }}</mat-icon>
            Mindestens 8 Zeichen
        </li>
        <li [class.valid]="passwordValidation.hasUppercase" [class.invalid]="!passwordValidation.hasUppercase">
            <mat-icon>{{ passwordValidation.hasUppercase ? 'check_circle' : 'cancel' }}</mat-icon>
            Mindestens ein Großbuchstabe
        </li>
        <li [class.valid]="passwordValidation.hasLowercase" [class.invalid]="!passwordValidation.hasLowercase">
            <mat-icon>{{ passwordValidation.hasLowercase ? 'check_circle' : 'cancel' }}</mat-icon>
            Mindestens ein Kleinbuchstabe
        </li>
        <li [class.valid]="passwordValidation.hasNumber" [class.invalid]="!passwordValidation.hasNumber">
            <mat-icon>{{ passwordValidation.hasNumber ? 'check_circle' : 'cancel' }}</mat-icon>
            Mindestens eine Zahl
        </li>
        <li [class.valid]="passwordValidation.hasSpecialChar" [class.invalid]="!passwordValidation.hasSpecialChar">
            <mat-icon>{{ passwordValidation.hasSpecialChar ? 'check_circle' : 'cancel' }}</mat-icon>
            Mindestens ein Sonderzeichen (empfohlen)
        </li>
        <li *ngIf="passwordConfirmCtrl.value?.length > 0" [class.valid]="passwordValidation.passwordsMatch" [class.invalid]="!passwordValidation.passwordsMatch">
            <mat-icon>{{ passwordValidation.passwordsMatch ? 'check_circle' : 'cancel' }}</mat-icon>
            Passwörter stimmen überein
        </li>
    </ul>
</div>

<div class="one-row">
    <span class="spacer"></span>
    <button
        mat-flat-button
        color="accent"
        (click)="save()"
        [disabled]="!isPasswordValid()"
    >
        Passwort speichern
    </button>
</div>
